export default __webpack_public_path__ + "static/media/no-data.1bdff802.svg";